export default __webpack_public_path__ + "static/media/error-image.6a72722e.svg";